'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:LicensesCtrl
 * @description
 * # LicensesCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	// FIX! replace this controller with my-licenses page, maybe only if the user is logged in with email/password as opposed to licenseKey/registeredTo
	.controller('LicensesCtrl', function ($scope, $location, $route, $uibModal, session, api, BUILD_DATE) {
		/**
		 * @type {MaintenanceSupport}
		 */
		$scope.support = {options:[],expired:[]};

		$scope.credentials = {
			licenseKey: localStorage.licenseKey,
			registeredTo: localStorage.registeredTo
		};

		$scope.tmp = {
			rememberMe:true,
		}

		/**
		 * On form submission
		 */
		$scope.login = function () {
			api.getRenewalCandidates($scope.credentials.licenseKey, $scope.credentials.registeredTo, $scope.tmp.rememberMe)
				.then(function (response) {
					$scope.support = response;
				});
		};

		$scope.enterDifferentLicenseKey = function () {
			$scope.support = null;
		};

		/**
		 * Sets the `selected` for all items.
		 * `renewMe` is a bad name, as this license page is used for more than just manual renewals now.
		 */
		$scope.setAllRenewMe = function (yn) {
			$scope.support.options
				.filter( option => !option.disabled )
				.forEach(option => option.selected = yn);
		};

		$scope.selectedCount = () => {
			return $scope.support?.options?.filter((o) =>o.selected)?.length;
		};

		/**
		 * Should the "disable auto-renew" button be disabled? Think of a worse name, I dare you.
		 */
		$scope.isDisableAutoRenewEnabled = () => {
			return $scope.support?.options?.find(o => o.autoRenew && o.selected);
		};

		/**
		 * Is at least one item checked?
		 */
		$scope.atLeastOneRenewMe = function () {
			return $scope.support?.options?.find(o => o.selected);
		};

		$scope.toggle = function (item) {
			if (item.disabled) {
				return;
			}
			item.selected = !item.selected;
			window.event.stopPropagation();
		};

		/**
		 * @return {MaintenanceOption[]}
		 */
		function renewalOptionsToEnableAutoRenewFor() {
			return $scope.support?.options
				.filter(o => o.selected)
				.filter(o => !o.autoRenew);
		}

		$scope.autoRenewSavings = () => {
			return renewalOptionsToEnableAutoRenewFor()
				?.map(o => o.renewalPrice * 0.1)
				?.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
		};

		$scope.updatePaymentInfo = () => {
			$location.path('update-payment-info')
				.search('licenseKey', $scope.credentials.licenseKey)
				.search('registeredTo', $scope.credentials.registeredTo);
		};

		/**
		 * Toggles things on the server, shows a toast, and updates the `$scope.support` with the updated auto-renewal candidates
		 * @param options {MaintenanceOption[]}
		 * @param autoRenewEnabled {boolean}
		 * @return {Promise<*>}
		 * @private
		 */
		async function _toggleAutoRenewEnabled(options, autoRenewEnabled) {
			let cartItemIds = options.map(o => o.cartItemId);
			$scope.support = await api.toggleAutoRenewForCartItemIds($scope.credentials.licenseKey, $scope.credentials.registeredTo, cartItemIds, autoRenewEnabled);
			window.toastr.info('Auto-renew ' + (autoRenewEnabled ? 'enabled' : 'disabled') + ' for ' + options.length + ' items', 'AutoRenew Update');
			return cartItemIds;
		}

		$scope.disableAutoRenewForCheckedOrders = async () => {
			let options = $scope.support.options
				.filter(o => o.autoRenew && o.selected);
			await _toggleAutoRenewEnabled(options, false);
		};

		$scope.enableAutoRenewForCheckedOrders = async () => {
			await $uibModal.open({
				templateUrl: 'views/modal-confirm-auto-renew-for-existing-orders.html?v=' + BUILD_DATE,
				scope: $scope,
			}).result;
			let options = renewalOptionsToEnableAutoRenewFor();
			let cartItemIds = await _toggleAutoRenewEnabled(options, true);
			if ( window.confirm('Auto-renew has been enabled for ' + cartItemIds.length + ' item' + (cartItemIds.length === 1 ? '' : 's') + '. Review payment information?')) {
				$scope.updatePaymentInfo();
			}
		};

		/**
		 * @param maintenanceOption {MaintenanceOption}
		 * @return {Promise<void>}
		 */
		$scope.showRenewalDetailsModal = async (maintenanceOption) => {
			/**
			 * @type {Promise<OrderAndRenewPreview>}
			 */
			const orderAndRenewPreview = api.getOrderAndRenewPreview($scope.credentials.licenseKey, $scope.credentials.registeredTo, maintenanceOption.cartItemId)
			await $uibModal.open({
				controller: 'OrderRenewCtrl',
				scope: $scope,
				templateUrl: 'views/modal-order-renew.html?v=' + BUILD_DATE,
				size: 'med',
				resolve: {
					orderAndRenewPreview: orderAndRenewPreview,
					isAdmin:false,
				}
			}).result.catch(()=>{}); // cancel will throw exception here
		};

		$scope.manuallyRenewCheckedOrders = function () {
			const requestActions = $scope.support.options
				.filter(function (o) {
					return o.selected;
				})
				.map(function (o) {
					return {action: 'Renew', cartItemId: o.cartItemId, registeredTo: o.company};
				});
			api.createCartAction(requestActions)
				.then(function (action) {
					session.addCartAction(action);
					$location.path('/checkout');
				});
		};

		/*
		///////////////////////////////////////////////////////////////////////////
		// INIT
		///////////////////////////////////////////////////////////////////////////
		*/
		const params = $route.current.params;
		if (params.licenseKey) {
			$scope.credentials = params;
			$scope.login();
		}


	});
